import React from "react"
import Image from "next/image"
import styled from "styled-components"
import Link from "next/link"
import { themeGet } from "@styled-system/theme-get"

export default function ListCard({ title, img, alt, link }) {
  return (
    <Link href={`${link}`} passHref legacyBehavior>
      <Wrapper>
        <RightBlock>
          <ImageWrapper>
            <Image
              src={img}
              alt={alt}
              fill
              sizes="100vw"
              style={{
                objectFit: "cover"
              }}
            />
          </ImageWrapper>
        </RightBlock>
        <Title>{title}</Title>
      </Wrapper>
    </Link>
  )
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 1.5em;
  padding: 1em 0;
  border-bottom: 0.2px solid rgba(255, 255, 255, 0);
  align-items: center;
  cursor: pointer;
  color: ${themeGet("colors.textsecondary")};
  // border-radius: 0.5em;
  // border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s;
  &:hover {
    // transition: 0.3s;
    color: ${themeGet("colors.primary")};
    border-bottom: 0.2px solid ${themeGet("colors.primary")};
  }
`

const Title = styled.div`
  font-size: 1em;
  flex: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  // max-height: 42px;
  font-weight: 500;
`

const RightBlock = styled.div`
  flex: 1;
  max-width: 100px;
`
const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 55%;
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
`
